import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  Theme,
  createStyles,
  makeStyles,
} from "@material-ui/core/styles";
import {
  Grid,
  TextField,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import VisibilityTwoToneIcon from "@material-ui/icons/VisibilityTwoTone";
import MailTwoToneIcon from "@material-ui/icons/MailTwoTone";
import {
  getCentreInvoice,
  createInvoice,
  getCenterInfo,
} from "../../actions/GenomicsAdminAction";
import ListAltTwoToneIcon from "@material-ui/icons/ListAltTwoTone";
import { TablePagination } from "@material-ui/core";
import moment from "moment";
import { Button } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

const StyledTableCell:any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#924A91",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
      padding: "5px",
      textTransform: "capitalize",
    },
  })
)(TableCell);

const StyledTableRow:any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      width: "90%",
      flexGrow: 21,
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentFilter: {
      width: "100%",
      padding: "0px 10px 10px 0px",
    },
    contentTable: {
      width: "100%",
      padding: "0px 0px 10px 0px",
      borderLeft: "solid 1px #0e416b",
      borderRight: "solid 1px #0e416b",
      borderBottom: "solid 1px #0e416b",
      marginTop: "20px",
      minHeight: "300px",
    },
    table: {
      minWidth: 700,
    },
    tableRow: {
      padding: "5px 0 5px 5px !important",
    },
    root: {
      flexGrow: 0,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  getCentreInvoice: any;
  centreInvoice: any;
  createInvoice: any;
  getCenterInfo: any;
  centerInfo: any;
  loading: any;
}
const CcInvoice: React.FC<Props> = ({
  getCentreInvoice,
  centreInvoice,
  createInvoice,
  getCenterInfo,
  centerInfo,
  loading,
}) => {
  const timer = useRef<any>(0);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [start_date, setStart_date] = useState<any>(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [startDate, setStartDate] = useState<any>(
    moment().format("YYYY-MM-DD")
  );
  const [end_date, setEnd_date] = useState<any>(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(moment().format("YYYY-MM-DD"));
  const [status, setStatus] = useState<any>("none");
  const [ladgerType, setLedgerType] = useState<any>("none");
  const [centre, setCentre] = useState<any>("");
  const [open, setOpen] = useState<boolean>(false);
  const [invoiceNo, setInvoiceNo] = React.useState<any>("");

  const history = useHistory();

  const dispatch = useDispatch();

  useEffect(() => {
    getCentreInvoice();
    getCenterInfo();
  }, []);
  const searchHandler = (e: any) => {
    e.preventDefault();
    getCentreInvoice(
      `?center__id=${centre}&start_date=${startDate}&end_date=${endDate}&invoice_no=${invoiceNo}`
    );
  };
  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = centreInvoice.links && centreInvoice.links.next.split("?")[1];
      getCentreInvoice(url);
    } else if (newPage < page) {
      let url =
        centreInvoice.links && centreInvoice.links.previous.split("?")[1];
      getCentreInvoice(url);
    }
    setPage(newPage as number);
  };
  const submitForm = async (e: any) => {
    e.preventDefault();
    const data: any = {
      center_id: centre,
      start_date: moment(start_date).format("YYYY-MM-DD"),
      end_date: moment(end_date).format("YYYY-MM-DD"),
    };

    await createInvoice(data);
    getCentreInvoice();
  };
  const clickLedgerView = (val: any) => {
    history.push({
      pathname: "/dashboard/gnadmin/cc_invoice_pdf",
      state: val,
    });
  };
  const clickInvoiceBreakup = (
    cName: any,
    sDate: any,
    eDate: any,
    invNo: any,
    tAmt: any,
    bDate: any,
    sAmt: any
  ) => {
    let data = {
      centre_name: cName,
      start_date: sDate,
      end_date: eDate,
      invoice_no: invNo,
      total_billed_amount: tAmt,
      bill_date: bDate,
      rcl_share_amt: sAmt,
    };
    localStorage.setItem("InvoiceBreakup", JSON.stringify(data));
    history.push(`/dashboard/gnadmin/cc_invoice_breakup`);
  };
  return (
    <>
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <div className={classes.contentHeader}>
          <h4>Create New Invoice</h4>
        </div>
        <form onSubmit={submitForm} className={classes.contentFilter}>
          <Grid
            container
            spacing={3}
            direction="row"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCentre(obj.id);
                  }
                }}
                getOptionDisabled={(option: any) => option.type === "prepaid"}
                freeSolo
                blurOnSelect
                options={centerInfo?.results}
                disableCloseOnSelect
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                onInputChange={(event, newInputValue) => {
                  getCenterInfo(`&name_or_code=${newInputValue}`);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Hospital/Doctor"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <TextField
                className="input"
                name="start_date"
                type="date"
                required
                label="Start Date"
                value={start_date}
                variant="outlined"
                inputProps={{
                  max: moment().subtract(1, "days").format("YYYY-MM-DD"),
                }}
                onChange={(e) => setStart_date(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <TextField
                name="end_date"
                type="date"
                required
                value={end_date}
                className="input"
                label="End Date"
                variant="outlined"
                inputProps={{
                  max: moment().subtract(1, "days").format("YYYY-MM-DD"),
                }}
                onChange={(e) => setEnd_date(e.target.value as string)}
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                style={{
                  height: "56px",
                  backgroundColor: "#43a047",
                  color: "#fff",
                }}
                fullWidth
                type="submit"
                disabled={loading}
              >
                Create Invoice
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                variant="contained"
                color="primary"
                style={{ height: "56px" }}
                fullWidth
                onClick={() => history.push("/dashboard/gnadmin/cc_invoice")}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
        <div className={classes.root}>
          <Grid container spacing={2}>
            <Grid container item xs={12}>
              <h4>Invoice Reprint</h4>
            </Grid>
            <form onSubmit={searchHandler} style={{ width: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={2}>
                  <TextField
                    variant="outlined"
                    label="Invoice No."
                    fullWidth
                    value={invoiceNo}
                    onChange={(e) => setInvoiceNo(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                  <Autocomplete
                    id="center"
                    onChange={(event, newValue) => {
                      if (newValue) {
                        let obj = JSON.parse(
                          JSON.stringify(newValue, null, " ")
                        );
                        setCentre(obj.id);
                      }
                    }}
                    freeSolo
                    blurOnSelect
                    getOptionDisabled={(option: any) =>
                      option.type === "prepaid"
                    }
                    options={centerInfo?.results || []}
                    disabled={centerInfo?.results === undefined}
                    disableCloseOnSelect
                    getOptionLabel={(option: any) =>
                      (option?.display_name === null
                        ? option?.name
                        : option?.display_name) +
                      "(" +
                      option?.center_code +
                      ")"
                    }
                    onInputChange={(event, newInputValue) => {
                      getCenterInfo(`&name_or_code=${newInputValue}`);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Hospital/Doctor"
                        variant="outlined"
                        fullWidth
                        required
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                  <TextField
                    label="From Date"
                    id="contract-date"
                    type="date"
                    value={startDate}
                    required
                    onChange={(e) => setStartDate(e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={2}>
                  <TextField
                    label="To Date"
                    id="contract-date"
                    type="date"
                    value={endDate}
                    required
                    onChange={(e) => setEndDate(e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{ height: "100%" }}
                    type="submit"
                    // onClick={searchHandler}
                  >
                    Search Invoice
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    style={{ height: "100%" }}
                    onClick={() =>
                      history.push("/dashboard/gnadmin/cc_invoice")
                    }
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </form>

            <Grid container item xs={12}>
              <TableContainer
                className={classes.tableContainer}
                component={Paper}
                style={{ maxHeight: "540px" }}
              >
                <Table stickyHeader aria-label="simple table">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">SNO.</StyledTableCell>
                      <StyledTableCell align="center">
                      Hospital/Doctor Name
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Invoice Number
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        From Date
                      </StyledTableCell>
                      <StyledTableCell align="center">To Date</StyledTableCell>
                      <StyledTableCell align="center">
                        RCL Share Amount
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Ledger View
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        Invoice Breakup
                      </StyledTableCell>
                      <StyledTableCell align="center">EMAIL</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {centreInvoice.results &&
                      centreInvoice.results.length > 0 &&
                      centreInvoice.results.map((val: any, index: any) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="center">
                            {index + 1}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {val?.display_name === null
                              ? val?.center
                              : val?.display_name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {val.invoice_no}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {moment(val.start_date).format("DD-MM-YYYY")}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {moment(val.end_date).format("DD-MM-YYYY")}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {Math.ceil(val?.rcl_share_amount)}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <VisibilityTwoToneIcon
                              color="secondary"
                              onClick={() => clickLedgerView(val)}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <ListAltTwoToneIcon
                              color="secondary"
                              onClick={() =>
                                clickInvoiceBreakup(
                                  val.center,
                                  val.start_date,
                                  val.end_date,
                                  val.invoice_no,
                                  Math.ceil(val.total_billed_amount),
                                  val.created_at,
                                  Math.ceil(val.rcl_share_amount)
                                )
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <MailTwoToneIcon color="primary" />
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                  </TableBody>
                  <TablePagination
                    rowsPerPageOptions={[]}
                    colSpan={3}
                    count={centreInvoice.count}
                    rowsPerPage={centreInvoice.page_size}
                    page={page}
                    onPageChange={handleChangePage}
                  />
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      </main>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  centreInvoice: state.GenomicsAdminReducer.centreInvoice,
  centerInfo: state.GenomicsAdminReducer.centerInfo,
  loading: state.GenomicsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getCentreInvoice,
  createInvoice,
  getCenterInfo,
})(CcInvoice);
